var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"text-right",attrs:{"title":_vm.title}},[_vm._v(_vm._s(_vm.displayValue)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }